import React, { useRef, useEffect, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Heading from 'components/shared/heading';
import HubspotForm from 'components/shared/hubspot-form';
import { useMedia } from 'react-use';
import styles from './styles.module.scss';

const FormBlock = ({
  title = null,
  description = null,
  formId,
  // Optional label set in WordPress; becomes `form_name` on the GTM event.
  formName = null,
  blockId = null,
  formTargetId,
  theme = null,
  image = null,
  formButtonJustify = 'end',
}) => {
  const imageContainerRef = useRef(null);

  const appendImageToCard = useCallback((cardId) => {
    const imageDiv = document.getElementById(`img-${cardId}`);

    if (imageDiv && imageContainerRef.current) {
      imageContainerRef.current.appendChild(imageDiv);
    }
  }, []);

  const [isClient, setIsClient] = useState(false);
  const isMobile = useMedia('(max-width: 1023px)', false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    if (image?.id) {
      appendImageToCard(image.id);
    }
  }, [image, appendImageToCard]);

  return (
    <section
      id={blockId}
      className={cn(styles.formBlock, {
        [styles.themeLight]: theme === 'light',
        [styles.themeDark]: theme === 'dark',
      })}
    >
      <div className={styles.inner}>
        <div className="container">
          <div className={styles.contentWrapper}>
            <div className={styles.left}>
              {((title && !image) || (title && isClient && isMobile)) && (
                <Heading className={styles.title} tag="h2" size="xl">
                  {title}
                </Heading>
              )}
              {image && <div className={styles.imageContainer} ref={imageContainerRef} />}
              {((description && !image) || (description && isClient && isMobile)) && (
                <div className={styles.content} dangerouslySetInnerHTML={{ __html: description }} />
              )}
            </div>

            <div className={styles.right}>
              {image && title && (!isClient || !isMobile) && (
                <Heading className={styles.title} tag="h2" size="xl">
                  {title}
                </Heading>
              )}
              {description && (!isClient || !isMobile) && image && (
                <div className={styles.content} dangerouslySetInnerHTML={{ __html: description }} />
              )}
              <HubspotForm
                formId={formId}
                formName={formName}
                targetId={formTargetId}
                formButtonJustify={formButtonJustify}
                // onFormSubmitted={onFormSubmitted}
                submitButtonClass="button button_theme_accent-primary button_size_sm hubspot_form_button"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

FormBlock.propTypes = {
  title: PropTypes.string,
  formName: PropTypes.string,
  description: PropTypes.string,
  formId: PropTypes.string.isRequired,
  blockId: PropTypes.string,
  formTargetId: PropTypes.string.isRequired,
  theme: PropTypes.oneOf(['light', 'dark']),
  image: PropTypes.shape({
    id: PropTypes.number,
  }),
  formButtonJustify: PropTypes.oneOf(['start', 'end', 'center']),
};

export default FormBlock;
